import { useState } from "react";

import coverImage from "../assets/cover.jpg";
import vegetables from "../assets/vegetables.jpg";
import meats from "../assets/meat.jpg";
import quantities from "../assets/prep.jpg";
import spices from "../assets/spices.png";
import SectionBadge from "./SectionBadge";

function Ingredients() {
  const items = [
    { img: spices, label: "بهارات مختارة" },
    { img: quantities, label: "كميات محسوبة" },
    { img: meats, label: "لحوم مختارة" },
    { img: vegetables, label: "خضار طازجة" },
  ];

  const [activeIndex, setActiveIndex] = useState(null);
  const [isChanging, setIsChanging] = useState(false);

  const currentImage = activeIndex === null ? coverImage : items[activeIndex].img;

  const handleClick = (index) => {
    if (activeIndex === index) return;
    setIsChanging(true);
    setTimeout(() => {
      setActiveIndex(index);
      setTimeout(() => setIsChanging(false), 50);
    }, 200);
  };

  return (
    <section
      dir="rtl"
      id="ingredients"
      className="
        w-full
        box-border
        relative
        z-[2]

        bg-[#F8ECE5]
        font-['Cairo']

        pt-[60px]
        px-20
        pb-0

        max-[1000px]:px-10

        max-[750px]:pt-10
        max-[750px]:px-[25px]

        max-[500px]:pt-8
        max-[500px]:px-4
      "
    >

      {/* تعريف شكل القص مرة وحدة فقط — هاد الشكل ثابت ومابيتغيّر أبداً */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
        <defs>
          <clipPath id="coverClip" clipPathUnits="objectBoundingBox">
            <path d="M0.04,0 H0.96 C0.985,0 1,0.02 1,0.05 V0.8 C1,0.83 0.985,0.85 0.96,0.85 H0.62 C0.575,0.85 0.555,0.865 0.555,0.905 C0.555,0.96 0.535,1 0.475,1 H0.04 C0.015,1 0,0.98 0,0.95 V0.05 C0,0.02 0.015,0 0.04,0 Z" />
          </clipPath>
        </defs>
      </svg>

      {/* الإطار ثابت دائمًا — بس الصورة جواه هي يلي بتتبدّل */}
      <div
        className="
          w-[calc(100%+160px)]
          -ml-20
          -mr-20

          h-[440px]

          relative
          box-border
          overflow-hidden

          [clip-path:url(#coverClip)]
          [-webkit-clip-path:url(#coverClip)]

          max-[1000px]:w-[calc(100%+80px)]
          max-[1000px]:-ml-10
          max-[1000px]:-mr-10

          max-[750px]:w-[calc(100%+50px)]
          max-[750px]:-ml-[25px]
          max-[750px]:-mr-[25px]
          max-[750px]:h-[320px]

          max-[500px]:w-[calc(100%+32px)]
          max-[500px]:-ml-4
          max-[500px]:-mr-4
          max-[500px]:h-[260px]
        "
      >
        <img
          src={currentImage}
          alt="مكونات طبختنا"
          className={`
            w-full
            h-full
            object-cover
            ${activeIndex === null ? "object-[center_70%]" : "object-center"}
            block
            transition-opacity
            duration-300
            ${isChanging ? "opacity-0" : ""}
          `}
        />
      </div>

      <div
        className="
          flex
          items-start
          justify-between
          gap-[60px]

          pt-[18px]

          w-full

          max-[1000px]:gap-6

          max-[750px]:flex-col
          max-[750px]:items-end
          max-[750px]:gap-8
          max-[750px]:pt-2
        "
      >

        <div
          className="
            flex-none
            w-[360px]

            text-right

            -mt-2

            max-[750px]:flex-none
            max-[750px]:w-full
            max-[750px]:text-right
          "
        >
          <div className="flex flex-wrap items-center justify-start gap-2 mb-3.5">
            {["حمل التطبيق", "مكونات طازجة", "مقادير دقيقة"].map((badge, index) => (
              <SectionBadge key={badge} delay={index * 0.35}>
                {badge}
              </SectionBadge>
            ))}
          </div>

          <h2
            className="
              m-0
              font-['Cairo']
              text-[28px]
              font-extrabold
              leading-[1.5]
              tracking-[-0.72px]
              text-[#120B0A]

              max-[750px]:text-2xl
              max-[500px]:text-xl
            "
          >
            <span className="block whitespace-nowrap max-[750px]:whitespace-normal">
              مكونات مختارة بعناية ومقادير
            </span>
            <span className="block whitespace-nowrap max-[750px]:whitespace-normal">
              مناسبة، لتحضّري طبختك بسهولة
            </span>
            <span className="block whitespace-nowrap max-[750px]:whitespace-normal">
              وبالطعم الذي تحبينه
            </span>
          </h2>
        </div>

        <div
          className="
            flex
            flex-row
            items-start
            gap-4
            shrink-0

            max-[750px]:justify-center
            max-[750px]:flex-wrap
            max-[750px]:w-full
          "
        >
          {items.map((item, index) => (
            <div
              key={item.label}
              onClick={() => handleClick(index)}
              className={`
                w-[153px]
                h-[176px]
                flex-none

                bg-white

                rounded-[18px]

                p-3

                box-border

                text-center

                cursor-pointer

                shadow-[0_2px_8px_rgba(0,0,0,0.04)]

                transition-transform
                duration-200

                hover:-translate-y-1

                max-[500px]:w-[130px]
                max-[500px]:h-auto
              `}
            >
              <div className="w-[129px] h-[129px] rounded-[14px] overflow-hidden mx-auto mb-[10px] max-[500px]:w-[106px] max-[500px]:h-[106px]">
                <img
                  src={item.img}
                  alt={item.label}
                  className="w-full h-full object-cover block"
                />
              </div>
              <p className="m-0 font-['Cairo'] text-[13px] font-medium text-[#222] whitespace-nowrap">
                {item.label}
              </p>
            </div>
          ))}
        </div>

      </div>

    </section>
  );
}

export default Ingredients;